import { z } from "zod";

/**
 * Validation regex to prevent XSS attacks by rejecting HTML/JS characters.
 * Rejects any string containing < or > characters which are the basis for HTML/JS injection.
 */
const safeTextRegex = /^[^<>]*$/;

/**
 * Error message for XSS validation failures
 */
const xssErrorMessage =
  "Invalid characters detected. HTML tags (<, >) are not allowed.";

/**
 * Zod string schema that rejects HTML/JS injection vectors.
 * Uses .regex() instead of .refine() to return a ZodString, preserving chainability
 * (e.g., .min(), .max(), .email() can still be used after this).
 *
 * @example
 * ```ts
 * const schema = z.object({
 * name: zSafeString().min(1, "Name is required")
 * });
 * ```
 */
export const zSafeString = (message: string = xssErrorMessage) => {
  return z.string().regex(safeTextRegex, {
    message: message,
  });
};
